
import { socialTemplates } from "./social";
import { businessTemplates } from "./business";
import { paymentTemplates } from "./payment";
import { entertainmentTemplates } from "./entertainment";
import { gamingTemplates } from "./gaming";
import type { LoginTemplate } from "./types";

export type { LoginTemplate } from "./types";

export const loginTemplates: LoginTemplate[] = [
  ...socialTemplates,
  ...businessTemplates,
  ...paymentTemplates,
  ...entertainmentTemplates,
  ...gamingTemplates
];

export const getTemplatesByCategory = () => {
  const categories = new Map<string, LoginTemplate[]>();
  
  loginTemplates.forEach(template => {
    if (!categories.has(template.category)) {
      categories.set(template.category, []);
    }
    categories.get(template.category)?.push(template);
  });
  
  return categories;
};